import { CommonError, CommonsStore, Logger, LoggerFactory } from "../index";
import { observable } from "mobx";

export abstract class RemoteExecutor {
  @observable public commons: CommonsStore;
  @observable public name: string;
  public log: Logger;

  protected constructor(name: string, commons: CommonsStore) {
    this.name = name;
    this.commons = commons;
    this.log = LoggerFactory.create(`RemoteExecutor [${name}]`);
  }

  public executeRemote = async <T>(
    execName: string,
    action: () => Promise<T>
  ): Promise<T> => {
    this.triggerEvent(execName);
    this.commons.setDataExchange();
    try {
      const result = await action();
      this.triggerEvent(`${execName}.success`, result);
      return result;
    } catch (e) {
      this.triggerEvent(`${execName}.error`, e);
      if (e.response && e.response.data) {
        this.commons.newError(e.response.data as CommonError); // todo wrap all errors in Error class
      } else {
        this.log.error("failed to load", e);
      }
      throw e;
    } finally {
      this.commons.resetDataExchange();
    }
  };

  public triggerEvent = (type: string, ...args: any[]): void => {
    this.commons.trigger(`${this.name}.${type}`, args);
  };

  public onEvent(type: string, callback: Function) {
    this.commons.on(`${this.name}.${type}`, callback);
  }
}
